import { useCallback } from "react";
import { tokenService } from "../services/tokenService";

export const useAuthenticatedFetch = () => {
  const authenticatedFetch = useCallback(
    async (url: string, options: RequestInit = {}): Promise<Response> => {
      return tokenService.makeAuthenticatedRequest(url, options);
    },
    []
  );

  return authenticatedFetch;
};
